module.exports = __webpack_public_path__ + "02_glasses_brown.6e54e1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/02_glasses_brown.png
// module id = Zzcv
// module chunks = 0